<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Translate</h6>
  <button (click)="close()" type="button" class="btn-close"></button>
</div>
@if (translationDomain) {
  <div class="modal-body">
    <div class="d-flex justify-content-between align-items-center">
      <span class="text-nowrap">Translate from</span>
      <img [ngSrc]="langService.getFlag(translationDomain.baseLocale ?? '')" [alt]="translationDomain.baseLocale"
           width="24"
           height="24" class="ms-3 me-3">
      <span>To</span>
      <i class="bi bi-arrow-right ms-3 me-3"></i>
      <app-dropdown-select class="form-control" [(ngModel)]="targetLocale" (ngModelChange)="getRates()">
        @for (locale of getAvailableLocales(); track locale) {
          <app-dropdown-select-option [value]="locale">
            <img [ngSrc]="langService.getFlag(locale ?? '')" [alt]="locale" width="24"
                 height="24" class="me-1">
            {{ locale }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>

    <div class="row mt-3">
      <div class="col">
        <app-dropdown-select class="form-control" [(ngModel)]="selectedBotPrompt" placeholder="Select a bot prompt">
          @for (botPrompt of botPrompts; track botPrompt.id) {
            <app-dropdown-select-option [value]="botPrompt">
              {{ botPrompt.name }}
            </app-dropdown-select-option>
          }
        </app-dropdown-select>
      </div>
    </div>

    @if (selectedBotPrompt) {
      <div class="row mt-3">
        <div class="col">
          <textarea class="form-control" [ngModel]="selectedBotPrompt.prompt" readonly rows="5"></textarea>
        </div>
      </div>
    }

    <div class="mt-3">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox" value="" id="overwrite" [(ngModel)]="overwrite">
        <label class="form-check-label" for="overwrite">
          Overwrite all existing translations
        </label>
      </div>
    </div>

    @if (rates) {
      <div class="row mt-3 text-center">
        @if (rates.rpd.limit) {
          <div class="col" [class.text-danger]="rates.rpd.isLimited()" title="Request Per Day">
            <b>RPD</b><br>{{ rates.rpd.current | bigNumber }}/{{ rates.rpd.limit | bigNumber }}
          </div>
        }
        @if (rates.rpm.limit) {
          <div class="col" [class.text-danger]="rates.rpm.isLimited()" title="Request Per Minute">
            <b>RPM</b><br>{{ rates.rpm.current | bigNumber }}/{{ rates.rpm.limit | bigNumber }}
          </div>
        }
        @if (rates.tpd.limit) {
          <div class="col" [class.text-danger]="rates.tpd.isLimited()" title="Token Per Day">
            <b>TPD</b><br>{{ rates.tpd.current | bigNumber }}/{{ rates.tpd.limit | bigNumber }}
          </div>
        }
        @if (rates.tpm.limit) {
          <div class="col" [class.text-danger]="rates.tpm.isLimited()" title="Token Per Minute">
            <b>TPM</b><br>{{ rates.tpm.current | bigNumber }}/{{ rates.tpm.limit | bigNumber }}
          </div>
        }
      </div>
    }
  </div>
}
<div class="modal-footer row border-0">
  @if (locked && targetLocale) {
    <div class="col-auto d-flex align-items-center">
      <div class="spinner-border me-2"></div>Processing<img [ngSrc]="langService.getFlag(targetLocale)" [alt]="targetLocale" width="24" height="24" class="mx-2">right now
    </div>
  }

  <div class="col text-end">
    <button (click)="close()" type="button" class="btn btn-secondary">Cancel</button>
    <button type="button" class="btn btn-primary fw-bold ms-2" [disabled]="locked || !targetLocale || !selectedBotPrompt" (click)="translate()">Translate</button>
  </div>
</div>
